import { BrowserRouter } from "react-router-dom";

import { Toaster } from "@/components/_ui/toaster";
import { NavigationProvider } from "@/components/navigation-controls/use-navigation-control-context";
import { useAuth } from "@/domain/_shared/auth/hooks/api/use-auth";
import { useSentryRoutes } from "@/lib/sentry";

import { routes } from "./app-router-config";

function InnerRouter() {
  const { authenticated } = useAuth();
  const routing = useSentryRoutes(routes(authenticated));

  return <>{routing}</>;
}

export function AppRouter() {
  return (
    <BrowserRouter>
      <NavigationProvider>
        <InnerRouter />
      </NavigationProvider>
      <Toaster />
    </BrowserRouter>
  );
}
